// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__PMUkg","loader-rotate":"loader_loader-rotate__mKWsv","loader-dash":"loader_loader-dash__AOgPd"};